<template>
  <div :class="['index-index-cates', 'icon-style-' + (item.opCategoryStyle ? item.opCategoryStyle.style : '90')]"  :style="[{'margin-top': widthScale * item.marginTop + 'px' || 0},{'margin-bottom': widthScale * item.marginBottom + 'px' || 0},{'background-image':'url('+item.baseImageUrl+')'}]">
    <div class="index-cates-inner" v-for="(icon,index) in item.iconList" :key="index" @click="toLink(icon, index)" :show="index > 0 && index <= 5">
      <img :src="icon.imgUrl" mode="widthFix"><span :style="[{'color':item.fontColor},{'font-size':item.fontSize*widthScale+'px'}]">{{icon.name}}</span>
    </div>
  </div>
</template>
<script>
import utils from '@/utils/common'
export default {
  data(){
    return{
      widthScale:  window.innerWidth / 750
    }
  },
  props: {
    contentPageId: {
      default: 0,
      type: Number
    },
    item: {
      default: function() {
          return {}
      },
      type: Object
    },
    sort: {
      default: 0,
      type: Number
    }
  },
  mounted() {
    gio("track", "moduleExposure", {indexId_var: String(this.contentPageId), entryType_vara:'运营分类', entryType_floor_var: String(this.sort)});
  },
  methods:{
    async toLink(item, index) {
      gio("track", "flowLocationClick", {indexId_var: String(this.contentPageId), entryType_vara:'运营分类', entryType_floor_var: String(this.sort), position_var:String(index), sort_var:'', positonName_var:item.name});
      switch (item.linkType) {
        // 商品分类
        case 1:
          this.$router.push({
            path: "/iconDetail",
            query: { iconid: item.id }
          })
          break;
        // 店铺
        case 3:       
          utils.jumpToNewPage({
              url: window.location.origin +'/h5user/brandindex?id=' + item.linkValue,
              noTitle: '1',
               action:{tm:"4090100",tp:{branchId:parseInt(item.linkValue)}}
          });
          break;
        case 6:
          // 链接
            if (item.linkValue) {
                let params = {}
                item.linkValue.split('?')[1] && item.linkValue.split('?')[1].split('&').forEach(item => {
                    let strArr = item.split('=');
                    params[strArr[0]] = strArr[1];
                });
                utils.jumpToNewPage({
                    url: item.linkValue,
                    barColor: params.naviBarColor && '#' + params.naviBarColor
                });
            }
          break;
        // 联系蜜蜂
        case 7:
            utils.jumpBeeLists()
            break;
        // 发现话题
        // case 5:         
        //   utils.jumpToNewPage({
        //     url: window.location.origin +'/h5user/discoverHottopic?hotId=' + item.linkValue,
        //     noTitle: '0'
        //   });
        //   break;
        //   // 发现
        // case 5:  
        //   utils.jumpToNewPage({
        //     url: window.location.origin +'/h5user/discoverUserDetails?discoverId=' + item.linkValue,
        //     noTitle: '0'
        //   });
        //   break;
        // 不跳转
        case 8:
          break;
        //跳转品牌 
        case 11:
          utils.jumpToNewPage({
            url: window.location.origin +'/h5user/brandlist?id=' + item.linkValue,
            noTitle: "1"
          })
          break;
      }
      utils.nativeMethod({tm:'4000101',tp:{module_evar: '运营分类'}})
    }
  }
}
</script>
<style lang="less" scoped>
.index-index-cates{
  display: block;
  overflow: hidden;
  // background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 20px 0;
}
.index-cates-inner{
  float: left;
  width: 20%;
  display: flex;
  flex-direction: column;
  // height: 140px;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
}
.index-index-cates .index-cates-inner:nth-child(-n+5) {
    margin-top: 0;
}
.icon-style-90 img {
  width: 90px;
  height: 90px;
}
.icon-style-104 img {
  width: 104px;
  height: 104px;
}
.index-cates-inner span{
  display: inline-block;
  max-width: 130px;
  height: 30px;
  line-height: 30px;
  font-size: 22px;
  padding-top: 23px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>